// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input[data-v-426bb8c1]{background:#fff;border:0;border-radius:5px;color:#555;font:22px/34px Roboto Condensed!important;height:50px;width:300px}input[data-v-426bb8c1]::-moz-placeholder{color:#999}input[data-v-426bb8c1]:-ms-input-placeholder{color:#999}input[data-v-426bb8c1]::placeholder{color:#999}", ""]);
// Exports
module.exports = exports;
